import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { buildSurveyDsKey, RestaurantsRepository } from '@timechef/features/restaurants/state';
import { Restaurant } from '@timechef/features/restaurants/state/restaurants.models';
import { Observable } from 'rxjs';
import { SwiperComponent } from 'swiper/angular';

@Component({
  selector: 'app-survey-campaign-modal',
  templateUrl: './survey-campaign-modal.component.html',
  styleUrls: ['./survey-campaign-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SurveyCampaignModalComponent implements OnInit {
  @Input() restaurantId?: number;

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  sliderOptions = { initialSlide: 0 };
  restaurants: (Restaurant & { surveyDS$: Observable<any> })[] = [];

  restaurant?: Restaurant & { surveyDS$: Observable<any> };

  innerControl = new FormControl<number | null>(null);
  constructor(
    private restaurantsRepo: RestaurantsRepository,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit() {
    this.innerControl.valueChanges.subscribe((id) => {
      this.changeRestaurant(id);
    });

    this.restaurants = this.restaurantsRepo.getRestaurantsWithSurveyCampaign().map((r) => {
      return { ...r, surveyDS$: this.restaurantsRepo.restaurantSurveyCampaignDetailDS.data$({ key: buildSurveyDsKey(r.id) }) };
    });

    if (this.restaurantId) {
      this.innerControl.setValue(this.restaurantId);
    }
  }

  changeRestaurant(id: number | null) {
    const rest = this.restaurants.find((r) => r.id === id);
    if (rest) {
      this.restaurant = rest;
    } else {
      this.restaurant = undefined;
    }
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }

  valueFn = (x: Restaurant) => x.id;
  displayFn = (x: Restaurant) => `${x.title}`;
}
